import * as React from 'react';
export const STSvg = React.forwardRef(function STSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#FCD669',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M8 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
        opacity: 0.9,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 8V4h1v4z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H0V2Zm0 6h16v2c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M.7 11.52A2.01 2.01 0 0 1 0 9.99V2.01C0 1.395.275.844.707.475a.504.504 0 0 1 .07.039L5 5.996.777 11.478a.5.5 0 0 1-.076.042Z',
      }),
    ),
  );
});
STSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var ST = {
  category: 'flag',
  colorable: false,
  name: 'ST',
  svg: STSvg,
};
